import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL, REGISTER_USER_REQUEST, REGISTER_USER_SUCCESS, REGISTER_USER_FAIL, LOAD_USER_REQUEST, LOAD_USER_SUCCESS, LOAD_USER_FAIL, LOGOUT_SUCCESS, FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAIL, RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAIL, CLEAR_ERRORS, UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_FAIL, VERIFICATION_CODE_REQUEST, VERIFICATION_CODE_SUCCESS, VERIFICATION_CODE_FAIL, VERIFY_CODE_REQUEST, VERIFY_CODE_SUCCESS, VERIFY_CODE_FAIL, USER_INTEREST_CREATE_REQUEST, USER_INTEREST_CREATE_SUCCESS, USER_INTEREST_CREATE_FAIL, GET_ALL_USER_INTEREST_REQUEST, GET_ALL_USER_INTEREST_FAIL, GET_ALL_USER_INTEREST_SUCCESS } from '../constants/userConstant'



export const userReducer = (state = { user: null, isAuthenticated: false, loading: true }, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case REGISTER_USER_REQUEST:
    case LOAD_USER_REQUEST:
      return {
        ...state,
        loading: true,
        isAuthenticated: false
      };
    case LOGIN_SUCCESS:
    case LOAD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload
      };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload
      }
    case LOGOUT_SUCCESS:
      return {
        loading: false,
        user: null,
        isAuthenticated: false
      }
    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case REGISTER_USER_FAIL:
    case LOAD_USER_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        error: action.payload
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null
      }
    default:
      return state;
  }
}

export const forgotPasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };

    case FORGOT_PASSWORD_FAIL:
    case RESET_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const profileReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: true
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isUpdated: action.payload
      };

    case UPDATE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
}

export const verificationReducer = (state = {}, action) => {
  switch (action.type) {
    case VERIFICATION_CODE_REQUEST:
    case VERIFY_CODE_REQUEST:
      return {
        ...state,
        loading: true
      };

    case VERIFICATION_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        verifyCodeSend: action.payload
      };

    case VERIFY_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        codeVerified: action.payload
      }

    case VERIFICATION_CODE_FAIL:
    case VERIFY_CODE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
}

// User Interest
export const userInterestReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_INTEREST_CREATE_REQUEST:
    case GET_ALL_USER_INTEREST_REQUEST:
      return {
        ...state,
        loading: true
      };

    case USER_INTEREST_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        createUserInterest: action.payload
      }

    case GET_ALL_USER_INTEREST_SUCCESS:
      return {
        ...state,
        loading: false,
        getAllUserInterest: action.payload
      }  

    case USER_INTEREST_CREATE_FAIL:
    case GET_ALL_USER_INTEREST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
}